import React, { useEffect, useState } from "react";
import "../ui/common.css";
import "../Styles/style.css";
import { Link } from "react-router-dom";
import config from "../config";

const BlogCards = () => {
  const [banner, setBanner] = useState(null);
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    fetch(`${config.API_BASE_URL}/banners/blogs`)
      .then((res) => res.json())
      .then((data) => {
        if (data.banners && data.banners.length > 0) {
          setBanner(data.banners[0]);
        }
      })
      .catch((err) => console.error("Error fetching banner:", err));
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [jobSeekersRes, blogsRes] = await Promise.all([
          fetch(
            `${config.API_BASE_URL}/content/job-seekers-blog-or-resources`
          ).then((res) => res.json()),
          fetch(`${config.API_BASE_URL}/content/blog-or-resources`).then(
            (res) => res.json()
          ),
        ]);

        const combined = [
          ...(jobSeekersRes.content || []),
          ...(blogsRes.content || []),
        ];

        // Remove duplicates by ID
        const uniqueBlogs = combined.filter(
          (blog, index, self) =>
            index === self.findIndex((b) => b.id === blog.id)
        );

        setBlogs(uniqueBlogs);
      } catch (err) {
        console.error("Error fetching blogs:", err);
      }
    };

    fetchData();
  }, []);

  return (
    <>
      {/* ✅ Dynamic Banner Section */}
      {banner && (
        <section
          className="Blog-Desktop-Banner blog-mobile"
          style={{
            backgroundImage: `url(/prosapiens-cms/public/${banner.banner_image})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className="overlay container">
            {/* This will render HTML content from API (title + description) */}
            <div dangerouslySetInnerHTML={{ __html: banner.content_text }} />
          </div>
        </section>
      )}

      <div className="container">
        <div className="blog-grid">
          {/* {blogs.map((blog, index) => (
            <div className="blog-card" key={index}>
              <div className="blog-content">
                <div
                  className="blog-excerpt"
                  dangerouslySetInnerHTML={{ __html: blog.content_text }}
                />
                {blog.content_image && (
                  <div className="blog-image">
                    <img
                      src={`/prosapiens-cms/public/${blog.content_image}`}
                      alt={blog.content_title}
                    />
                  </div>
                )}
              </div>
            </div>
          ))} */}

          {blogs.map((blog) => (
            <div className="blog-card" key={blog.id}>
              <Link to={`/blogs/${blog.id}`}>
                <div className="blog-content">
                  <div
                    className="blog-excerpt"
                    dangerouslySetInnerHTML={{ __html: blog.content_text }}
                  />
                  {blog.content_image && (
                    <div className="blog-image">
                      <img
                        src={`/prosapiens-cms/public/${blog.content_image}`}
                        alt={blog.content_title}
                      />
                    </div>
                  )}
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default BlogCards;
